import * as PersonComponents from "../../Person";
import { IconGuardian } from "../Icon";

export type GuardianIconNameDescriptionProps = Omit<PersonComponents.PersonIconNameDescriptionProps, "person"> & {
	guardian: IconGuardian;
};

export function GuardianIconNameDescription({ guardian, description, ...props }: GuardianIconNameDescriptionProps) {
	const defaultDescription = "Parent/Guardian";

	return (
		<PersonComponents.PersonIconNameDescription
			person={guardian.person}
			description={description ?? defaultDescription}
			linkID={guardian.id}
			{...props}
		/>
	);
}
